module.exports = __webpack_public_path__ + "img/gaming.a021268e.svg";